"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetType = void 0;
var ResetType;
(function (ResetType) {
    ResetType[ResetType["Yaw"] = 0] = "Yaw";
    ResetType[ResetType["Full"] = 1] = "Full";
    /**
     * Second pose for calibrating mounting rotation
     */
    ResetType[ResetType["Mounting"] = 2] = "Mounting";
})(ResetType = exports.ResetType || (exports.ResetType = {}));
